export default __webpack_public_path__ + "static/media/add_circle_outline_24px_outlined.584865ad.svg";